import * as React from 'react'

export interface SuperUserIconProps {
  className?: string
}

export const SuperUserIcon = ({ className = '' }: SuperUserIconProps) =>
  React.createElement('i', {
    className: `fas fa-user-secret super-user-icon ${className}`
  })